var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/chevronRight.f22b0041.png","uri@3x": __webpack_public_path__ + "static/media/chevronRight.f2a2dc47.png","uri@2x": __webpack_public_path__ + "static/media/chevronRight.5560f624.png",
    width: 16,
    height: 16
});